import { render, staticRenderFns } from "./LoteCapa.vue?vue&type=template&id=029b6602"
import script from "./LoteCapa.vue?vue&type=script&lang=js"
export * from "./LoteCapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports